/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  FinancialPlanSmallTotalDto,
  FinancialPlanSmallTotalDtoFromJSON,
  FinancialPlanSmallTotalDtoFromJSONTyped,
  FinancialPlanSmallTotalDtoToJSON,
} from "./FinancialPlanSmallTotalDto";
import {
  FinancialPlanStatus,
  FinancialPlanStatusFromJSON,
  FinancialPlanStatusFromJSONTyped,
  FinancialPlanStatusToJSON,
} from "./FinancialPlanStatus";

/**
 *
 * @export
 * @interface FinancialPlanLastDraftOrOnApprovalDtoFinancialPlan
 */
export interface FinancialPlanLastDraftOrOnApprovalDtoFinancialPlan {
  /**
   *
   * @type {FinancialPlanStatus}
   * @memberof FinancialPlanLastDraftOrOnApprovalDtoFinancialPlan
   */
  status: FinancialPlanStatus;
  /**
   *
   * @type {string}
   * @memberof FinancialPlanLastDraftOrOnApprovalDtoFinancialPlan
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof FinancialPlanLastDraftOrOnApprovalDtoFinancialPlan
   */
  monthPlanId: string;
  /**
   *
   * @type {number}
   * @memberof FinancialPlanLastDraftOrOnApprovalDtoFinancialPlan
   */
  number: number;
  /**
   *
   * @type {number}
   * @memberof FinancialPlanLastDraftOrOnApprovalDtoFinancialPlan
   */
  monthWeekPosition: number;
  /**
   *
   * @type {Date}
   * @memberof FinancialPlanLastDraftOrOnApprovalDtoFinancialPlan
   */
  createdAt: Date;
  /**
   *
   * @type {Date}
   * @memberof FinancialPlanLastDraftOrOnApprovalDtoFinancialPlan
   */
  from: Date;
  /**
   *
   * @type {Date}
   * @memberof FinancialPlanLastDraftOrOnApprovalDtoFinancialPlan
   */
  to: Date;
  /**
   *
   * @type {boolean}
   * @memberof FinancialPlanLastDraftOrOnApprovalDtoFinancialPlan
   */
  closesWeek: boolean;
  /**
   *
   * @type {number}
   * @memberof FinancialPlanLastDraftOrOnApprovalDtoFinancialPlan
   */
  month: number;
  /**
   *
   * @type {number}
   * @memberof FinancialPlanLastDraftOrOnApprovalDtoFinancialPlan
   */
  year: number;
  /**
   *
   * @type {FinancialPlanSmallTotalDto}
   * @memberof FinancialPlanLastDraftOrOnApprovalDtoFinancialPlan
   */
  plan: FinancialPlanSmallTotalDto;
  /**
   *
   * @type {FinancialPlanSmallTotalDto}
   * @memberof FinancialPlanLastDraftOrOnApprovalDtoFinancialPlan
   */
  fact: FinancialPlanSmallTotalDto;
}

export function FinancialPlanLastDraftOrOnApprovalDtoFinancialPlanFromJSON(
  json: any
): FinancialPlanLastDraftOrOnApprovalDtoFinancialPlan {
  return FinancialPlanLastDraftOrOnApprovalDtoFinancialPlanFromJSONTyped(json, false);
}

export function FinancialPlanLastDraftOrOnApprovalDtoFinancialPlanFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FinancialPlanLastDraftOrOnApprovalDtoFinancialPlan {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    status: FinancialPlanStatusFromJSON(json["status"]),
    id: json["id"],
    monthPlanId: json["monthPlanId"],
    number: json["number"],
    monthWeekPosition: json["monthWeekPosition"],
    createdAt: new Date(json["createdAt"]),
    from: new Date(json["from"]),
    to: new Date(json["to"]),
    closesWeek: json["closesWeek"],
    month: json["month"],
    year: json["year"],
    plan: FinancialPlanSmallTotalDtoFromJSON(json["plan"]),
    fact: FinancialPlanSmallTotalDtoFromJSON(json["fact"]),
  };
}

export function FinancialPlanLastDraftOrOnApprovalDtoFinancialPlanToJSON(
  value?: FinancialPlanLastDraftOrOnApprovalDtoFinancialPlan | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    status: FinancialPlanStatusToJSON(value.status),
    id: value.id,
    monthPlanId: value.monthPlanId,
    number: value.number,
    monthWeekPosition: value.monthWeekPosition,
    createdAt: value.createdAt.toISOString(),
    from: value.from.toISOString(),
    to: value.to.toISOString(),
    closesWeek: value.closesWeek,
    month: value.month,
    year: value.year,
    plan: FinancialPlanSmallTotalDtoToJSON(value.plan),
    fact: FinancialPlanSmallTotalDtoToJSON(value.fact),
  };
}
